import React, { HTMLAttributes } from 'react';
import { css } from '@compiled/react';
import Atlas from '../../icons/atlas.svg';
import Bamboo from '../../icons/bamboo.svg';
import Clover from '../../icons/clover.svg';
import Crowd from '../../icons/crowd.svg';
import Crucible from '../../icons/crucible.svg';
import Fisheye from '../../icons/fisheye.svg';
import Sourcetree from '../../icons/sourcetree.svg';
import Halp from '../../icons/halp.svg';
import AgileInsidersNewsletter from '../../icons/agileNewsletter.svg';
import Git from '../../icons/git.svg';
import Marketing from '../../icons/generalMarketingOptIn.svg';

const styles = css({
  width: '48px',
  height: '48px',
});

export const AtlasIcon = (attributes: HTMLAttributes<object>) => <Atlas {...attributes} css={styles} />;

export const BambooIcon = (attributes: HTMLAttributes<object>) => <Bamboo {...attributes} css={styles} />;

export const CloverIcon = (attributes: HTMLAttributes<object>) => <Clover {...attributes} css={styles} />;

export const CrowdIcon = (attributes: HTMLAttributes<object>) => <Crowd {...attributes} css={styles} />;

export const CrucibleIcon = (attributes: HTMLAttributes<object>) => <Crucible {...attributes} css={styles} />;

export const FisheyeIcon = (attributes: HTMLAttributes<object>) => <Fisheye {...attributes} css={styles} />;

export const SourcetreeIcon = (attributes: HTMLAttributes<object>) => <Sourcetree {...attributes} css={styles} />;

export const HalpIcon = (attributes: HTMLAttributes<object>) => <Halp {...attributes} css={styles} />;

export const GitIcon = (attributes: HTMLAttributes<object>) => <Git {...attributes} css={styles} />;

export const MarketingIcon = (attributes: HTMLAttributes<object>) => <Marketing {...attributes} css={styles} />;

export const AgileInsidersNewsletterIcon = (attributes: HTMLAttributes<object>) => (
  <AgileInsidersNewsletter {...attributes} css={styles} />
);

BambooIcon.displayName = 'BambooIcon';
CloverIcon.displayName = 'CloverIcon';
CrowdIcon.displayName = 'CrowdIcon';
CrucibleIcon.displayName = 'CrucibleIcon';
FisheyeIcon.displayName = 'FisheyeIcon';
SourcetreeIcon.displayName = 'SourcetreeIcon';
HalpIcon.displayName = 'HalpIcon';
GitIcon.displayName = 'GitIcon';
MarketingIcon.displayName = 'MarketingIcon';
AgileInsidersNewsletterIcon.displayName = 'AgileInsidersNewsletterIcon';
